<template>
  <div class="centerx labelx rounded-item shadow-md" id="profile" v-if="this.userInfo">
    <vx-card>
      <div class="setting-card-hidden">
        <div class="setting-card-scroll">
          <!-- <p
            style="color:#FF0000; font-size: 13px"
            class="ml-3 mb-3"
          >(*) Please call 832-968-6668 to change the information</p>-->
          <vs-row>
            <vs-col vs-w="6">
              <h4 class="text-2xl font-bold">Basic Information</h4>
              <form class="centerx labelx">
                <vs-input label="Name" class="w-5/6" v-model="userInfo.name" :maxlength="254" disabled />
                <vs-input label="Short Name" class="w-5/6" v-model="userInfo.short_name" :maxlength="254" disabled />
                <vs-input label="Phone" class="w-5/6" v-model="userInfo.phone" disabled />
                <vs-input label="Address" class="w-5/6" v-model="userInfo.address" disabled />
                <vs-input label="City" class="w-5/6" v-model="userInfo.city" />
                <vs-input label="Country Code" class="w-5/6" v-model="userInfo.country_code" />
                <div class="flex w-5/6 centerx labelx">
                  <div class="w-1/2 pr-3">
                    <vs-input label="State Code" v-model="userInfo.state_code" class="w-full" />
                  </div>
                  <div class="w-1/2 pl-3">
                    <vs-input label="Postal Code" v-model="userInfo.postal_code" class="w-full" />
                  </div>
                </div>
                <label>Logo image</label>
                <image-uploader
                  v-if="userInfo.logo_image !== undefined"
                  @uploaded-done="handleUploaded"
                  type="#logo"
                  :image="(userInfo.logo_image != null) ? userInfo.logo_image :''"
                ></image-uploader>
              </form>
            </vs-col>
            <vs-col vs-w="6">
              <h4 class="text-2xl font-bold">Business Details</h4>
              <form class="centerx" style="margin-top:8px;">
                <label class="text">Open Time</label>
                <vs-textarea style="background-color:#ffffff" class="5/6 opentime" v-model="userInfo.open_time"></vs-textarea>
                <vs-input label="Industry ID" class="w-full mx-0 mb-3" v-model="userInfo.industry_id" />
                <label class="text">Description</label>
                <vs-textarea style="background-color:#ffffff" class="5/6 description" v-model="userInfo.description"></vs-textarea>
                <label>Cover image</label>
                <image-uploader
                  v-if="userInfo.cover_image !== undefined"
                  @uploaded-done="handleUploaded"
                  type="#cover"
                  :image="(userInfo.cover_image != null) ? userInfo.cover_image : ''"
                ></image-uploader>
              </form>
            </vs-col>
          </vs-row>
          <div class="flex justify-center py-6">
            <vs-button type="filled" color="primary" @click="saveChanges" style="min-width: 140px;">Save</vs-button>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
import ImageCropper from "./ImageCropper";

export default {
  components: { "image-uploader": ImageCropper },
  name: "vs-profile",
  data() {
    return {
      name: "",
      userInfo: {},
      loaded_data_num: 0,
      isOpenLoading: false,
      action_type: ''
    };
  },
  watch: {
    loaded_data_num: {
      immediate: true,
      handler() {
        if(this.loaded_data_num >= 1) {
          this.closeLoading();
        } else {
          this.action_type = 'Get';
          this.openLoadingInDiv();
        }
      }
    }
  },
  methods: {
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
        if(this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title:'Notification',
          //   text: this.action_type + ' staff failed',
          //   color:'danger',
          //   position:'top-right'})
          // this.$vs.dialog({
          //   color: 'danger',
          //   title: 'Notification',
          //   text: this.action_type + 'data failed',
          //   acceptText: 'OK'
          // })
        }
      }, 10000);
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);

    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    saveChanges() {
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      let loaded_num = 0;
      delete this.userInfo.name;
      delete this.userInfo.short_name;
      delete this.userInfo.phone;
      delete this.userInfo.address;
      this.$store
        .dispatch("auth/UPDATE_BUSINESS_INFO", this.userInfo)
        .then(() => {
          loaded_num++;
          if(loaded_num == 2) {
            this.closeLoading();
          }
          this.$vs.notify({
            title: "Notification",
            text: "Updated Successfully",
            color: "success",
            position: "top-right"
          });
        }).catch(() => {
          this.action_type = 'Update';
        });
      this.$store.dispatch("auth/GET_USER_INFO").then(() => {
        loaded_num++;
        if(loaded_num == 2) {
          this.closeLoading();
        }
      }).catch(() => {
        this.action_type = 'Get';
      });
    },
    handleUploaded(image) {
      if (image.type == "#logo") {
        this.userInfo.logo_image = image.image_url;
      } else if (image.type == "#cover") {
        this.userInfo.cover_image = image.image_url;
      }
    }
  },
  created() {
    this.$store.dispatch("auth/GET_USER_INFO").then((response, reject) => {
      this.userInfo = Object.assign({}, this.$store.state.auth.userInfo);
      this.loaded_data_num++;
      this.$emit('LoadDataComplete');
      if (reject == "Version mismatch") {
        this.$router.push("/pages/login");
      }
    });
  }
};
</script>